//const imgip = 'http://101.43.39.117:9201/'
let actionRequestUrl = 'http://101.43.39.117:9311/api/Upload/Upload'; //请求服务器接口地址,
let exportReportUrl = 'http://101.43.39.117:9311/api/Upload/UploadExportReport'; //请求服务器接口地址,

function getImgUrl(icon) {
    console.log(icon);
    return this.imgip + icon;
}

export default {
    //imgip,
    actionRequestUrl,
    exportReportUrl,
    getImgUrl
}